import {from, Observable, of} from 'rxjs';
import {catchError, concatMap, map, reduce} from 'rxjs/operators';
import {JustificationToValidateRef} from '@model/legal-absence-justification';

export interface JustificationValidationSummary {
  succeeded: number;
  failed: number;
}

export function validateJustificationsSequentially(
  items: JustificationToValidateRef[],
  validate: (item: JustificationToValidateRef) => Observable<void>
): Observable<JustificationValidationSummary> {
  if (!items || items.length === 0) {
    return of({succeeded: 0, failed: 0});
  }
  return from(items).pipe(
    concatMap(item => validate(item).pipe(
      map(() => true),
      catchError(() => of(false))
    )),
    reduce((summary: JustificationValidationSummary, isSuccess: boolean) => isSuccess
      ? {...summary, succeeded: summary.succeeded + 1}
      : {...summary, failed: summary.failed + 1}, {succeeded: 0, failed: 0})
  );
}

export function buildValidationSummaryMessage(summary: JustificationValidationSummary, isValidateAction: boolean = true): string {
  const validated = summary.succeeded > 1 ? `${summary.succeeded} justificatifs validés` : `${summary.succeeded} justificatif validé`;
  const rejected = summary.succeeded > 1 ? `${summary.succeeded} justificatifs refusés` : `${summary.succeeded} justificatif refusé`;
  if (summary.failed === 0) {
    return isValidateAction ? validated : rejected;
  }
  if (summary.succeeded === 0 && isValidateAction) {
    return summary.failed === 1
      ? 'Échec de la validation du justificatif'
      : `Échec de la validation de ${summary.failed} justificatifs`;
  } else if (summary.succeeded === 0 && !isValidateAction) {
    return summary.failed === 1
      ? 'Échec du refus du justificatif'
      : `Échec du refus de ${summary.failed} justificatifs`;
  }
  return `${validated}, ${summary.failed} en erreur`;
}
